"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isResponsiveMode(node) {
  return typeof node === 'string' && ['desktop', 'mobile', 'auto'].includes(node);
}

exports.default = isResponsiveMode;